import { Component, OnInit } from '@angular/core';
import { NavController, ModalController, NavParams } from 'ionic-angular';
import { DailyWageSetService } from './../../services/dailywageset.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { AlertService } from './../../providers/alert.service';
import { PageDefault } from './../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { AppConfig } from './../../app/app.config';
import { SetDailyWagesPage } from './setdailywages';
import { DailyWagesModel, DailyWagesRulesModel } from './../../models/dailywageset.model';
import { List } from 'linqts';
import * as $ from 'jquery';

@Component({
    selector: 'page-dailywageset',
    templateUrl: 'dailywageset.html',
    providers: [
        DailyWageSetService,
    ]
})
export class DailywagesetPage {
    constructor(
        private dailywageset: DailyWageSetService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private modalCtrl: ModalController,
        private navpar: NavParams,
        private config: AppConfig,
        public navCtrl: NavController,
        private alert: AlertService
    ) { }

    modelList: DailyWagesModel[] = [];
    // records: DailyWagesModel[] = [];
    // paras = new DailyWageSetInput();
    // pagesize: number = PageDefault.PageSize();
    // searchUser: string;

    ionViewDidEnter() {
        this.getDailywageSet();
    }
    
    getDailywageInput = {
        subUserName: '',
        pageIndex: 1,
        pageSize: PageDefault.PageSize(),
    };
    hasmore = false;
    isHave = true;

    //设置日工资比例
    dailywages(userName) {
        this.navCtrl.push(SetDailyWagesPage, { userName: userName });
    }

    getDailywageSet() {
        let load = this.loadding.showLoding();
        return this.dailywageset.getDirectSubUser(this.getDailywageInput).then(s => {
            this.loadding.closeLoading(load);
            if (this.getDailywageInput.pageIndex == 1) {
                this.modelList = [];
                this.modelList = s.List;
                if (s.List.length < s.PageCount) {
                    this.hasmore = true;
                } else {
                    this.hasmore = false;
                }
            } else {
                this.modelList = this.modelList.concat(s.List);
                if (this.modelList.length < s.PageCount) {
                    this.hasmore = true;
                }
                else {
                    this.getDailywageInput.pageIndex = 1;
                    this.hasmore = false;
                }
            }
            if (this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        }).catch(() => {
            this.loadding.closeLoading(load);
        });
    }

    //下拉重新加载
    //TQQ 2018-06-12
    doRefresh(refresher) {
        this.getDailywageInput.pageIndex = 1;
        this.getDailywageSet().then(() => {
            refresher.complete();
        });
    }

    //上拉获取下一页信息
    //TQQ 2018-06-12
    doInfinite(infiniteScroll) {
        this.getDailywageInput.pageIndex++;
        this.getDailywageSet().then(() => {
            infiniteScroll.complete();
        });
    }

}

export class DailyWageSetInput {
    UserName: string;
    PageIndex: number;
    StartDate: string = PageDefault.startDate();
    EndDate: string = PageDefault.endDate();
    PageSize: number = PageDefault.PageSize();
}




// WEBPACK FOOTER //
// ./src/pages/dailywageset/dailywageset.ts